// extracted by mini-css-extract-plugin
export default {"card":"card--v5zCd","container":"container--cca6L","panel":"panel--KfNRB"};